import noop from 'lodash/noop'
import {call, put, takeLatest} from 'redux-saga/effects'

import * as kickboxActions from '../actions/kickbox'
import {onStatus} from '../api/api'
import {validateEmail} from '../api/kickbox'

export function* validateEmailWorker({payload: email}) {
  yield put(kickboxActions.validateEmailPending())
  try {
    const response = yield call(validateEmail, email)
    onStatus({
      OK: noop,
      DEFAULT: () => {
        throw new Error('Invalid email')
      },
    })(response)
    yield put(kickboxActions.validateEmailSuccess())
  } catch (err) {
    yield put(kickboxActions.validateEmailFailure(err))
  }
}

export function* validateEmailSaga() {
  yield takeLatest(kickboxActions.VALIDATE_EMAIL, validateEmailWorker)
}
